// extracted by mini-css-extract-plugin
export var label = "_iy-2";
export var slideContainer = "_iy-0";
export var slider = "_iy-1";